import { NAME_PATTERN } from 'helpers/Constants';
import { required, stateZipMatch } from 'helpers/CommonValidations';

const validations = {
  maritalStatus: (state) => {
    return required('maritalStatus', state.maritalStatus);
  },
  isMarried: (state) => {
    return required('isMarried', state.isMarried);
  },
  spouseFirstName: (state) => {
    const value = state.spouseFirstName;
    if (value && value.match(NAME_PATTERN)) {
      return {
        spouseFirstName:
          'Cannot include the following special characters: #%&{}\\<>*?/$!":@+`|=~^()'
      };
    }
    return required('spouseFirstName', value);
  },
  spouseLastName: (state) => {
    const value = state.spouseLastName;
    if (value && value.match(NAME_PATTERN)) {
      return {
        spouseLastName:
          'Cannot include the following special characters: #%&{}\\<>*?/$!":@+`|=~^()'
      };
    }
    return required('spouseLastName', value);
  },
  spouseAddress: (state) => {
    return required('spouseAddress', state.spouseAddress);
  },
  spouseCity: (state) => {
    return required('spouseCity', state.spouseCity);
  },
  spouseState: (state) => {
    const value = state.spouseState;
    if (value && state.spouseZip) {
      return stateZipMatch('spouseState', value, 'spouseZip', state.spouseZip);
    }
    return required('spouseState', value);
  },
  spouseZip: (state) => {
    const value = state.spouseZip;
    if (value && value.length < 5) {
      return { spouseZip: 'Must be 5 digits' };
    }
    if (value && state.spouseState) {
      return stateZipMatch(
        'spouseState',
        state.spouseState,
        'spouseZip',
        value
      );
    }
    return required('spouseZip', value);
  }
};

export default validations;
